import { render, staticRenderFns } from "./SecurityCodeRegistration.vue?vue&type=template&id=fe6128c8&scoped=true&"
import script from "./SecurityCodeRegistration.vue?vue&type=script&lang=js&"
export * from "./SecurityCodeRegistration.vue?vue&type=script&lang=js&"
import style0 from "./SecurityCodeRegistration.vue?vue&type=style&index=0&id=fe6128c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6128c8",
  null
  
)

export default component.exports